import React from "react";

const Menu = () => {
  return (
    <>
      <p>
        <a href="#home">Home</a>
      </p>
      <p>
        <a href="#wgpt3">What is GPT</a>
      </p>
      <p>
        <a href="#possibility">Open AI</a>
      </p>
      <p>
        <a href="#features">Case Study</a>
      </p>
      <p>
        <a href="#blog">Library</a>
      </p>
    </>
  );
};

export default Menu;
